import React, { useState } from 'react';
import { buildPosterUrl, fmtDuration } from '../../utils/format';

export default function CoverPlate({ video, ratio = '2/3', radius = 14, size = 'md' }) {
    const [imgError, setImgError] = useState(false);
    const posterSrc = buildPosterUrl(video?.poster_url);
    const showImg = posterSrc && !imgError;

    const metaSize = size === 'sm' ? 8.5 : size === 'lg' ? 11 : 10;

    const ep    = video?.episode_number ?? video?.ep;
    const total = video?.total_episodes ?? video?.total;
    const dur   = video?.duration;
    const fresh = video?.fresh || (video?.created_at && Date.now() - new Date(video.created_at) < 3 * 86400000);

    return (
        <div style={{
            position: 'relative', width: '100%', aspectRatio: ratio,
            borderRadius: radius, overflow: 'hidden',
            background: '#0D0D0D', border: '1px solid #1F1F23',
            isolation: 'isolate',
        }}>
            {showImg ? (
                <img
                    src={posterSrc}
                    alt={video?.title || ''}
                    onError={() => setImgError(true)}
                    style={{
                        position: 'absolute', inset: 0,
                        width: '100%', height: '100%',
                        objectFit: 'cover',
                    }}
                />
            ) : (
                /* Fallback: dark plate with diagonal grain */
                <div style={{
                    position: 'absolute', inset: 0,
                    background: 'repeating-linear-gradient(135deg, #0f0f12 0 8px, #131316 8px 9px)',
                }} />
            )}

            {/* Bottom gradient for readability */}
            <div style={{
                position: 'absolute', left: 0, right: 0, bottom: 0, height: '55%',
                background: 'linear-gradient(transparent, rgba(0,0,0,0.82))',
                pointerEvents: 'none',
            }} />

            {/* EP badge */}
            {ep != null && total > 1 && (
                <div style={{
                    position: 'absolute', top: 8, left: 8,
                    padding: '2px 6px',
                    background: 'rgba(0,0,0,0.68)',
                    border: '0.5px solid rgba(255,255,255,0.18)',
                    borderRadius: 4,
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: metaSize, color: 'rgba(255,255,255,0.9)',
                    letterSpacing: 0.3,
                }}>
                    EP{String(ep).padStart(2, '0')}/{String(total).padStart(2, '0')}
                </div>
            )}

            {/* Fresh dot */}
            {fresh && (
                <div style={{
                    position: 'absolute', top: 10, right: 10,
                    width: 7, height: 7, borderRadius: 7,
                    background: '#e60073',
                    boxShadow: '0 0 8px #e60073',
                }} />
            )}

            {/* Duration */}
            {dur && (
                <div style={{
                    position: 'absolute', left: 8, bottom: 7,
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: metaSize, color: 'rgba(255,255,255,0.75)',
                    letterSpacing: 0.3,
                }}>
                    {fmtDuration(dur)}
                </div>
            )}
        </div>
    );
}
